import { Component, OnInit } from '@angular/core';
import {CommentDialogComponent} from './comment-dialog.component';

@Component({
    standalone: false,
    selector: 'particle-support-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.scss']
})
export class SupportCommentDialogComponent extends CommentDialogComponent implements OnInit {
  constructor() {
    super();
    this.conversationType = 3;
    this.messageType = 0;
    this.scopeInt = 3;
  }

  ngOnInit() {
    if (this.data && this.data.componentInfo && this.data.componentInfo.data) {
      this.contextId = this.data.componentInfo.data;
    }
  }

}
